import axiosActionsFactory from '../../axiosHelpers';
import { UrlService } from '../../../../services';
import { getSelectedCompany } from '../../../selectors';

export const GET_PROVIDER_ACCOUNT_AUTH_METHODS = axiosActionsFactory('GET_PROVIDER_ACCOUNT_AUTH_METHODS');

const getProviderAccountAuthMethods = (accountId, contextCompanyId, requestBody) => (dispatch) => dispatch({
  type: GET_PROVIDER_ACCOUNT_AUTH_METHODS.START,
  payload: {
    request: {
      url: UrlService.providerAccountAuthMethods(accountId),
      method: 'post',
      params: { contextCompanyId },
      data: requestBody,
    },
  },
});

export const getAccountAuthMethods = (accountId, vins) => (dispatch, getState) => {
  const state = getState();
  const contextCompanyId = getSelectedCompany(state);

  return dispatch(getProviderAccountAuthMethods(accountId, contextCompanyId, vins));
};
